export default __webpack_public_path__ + "8c3a4be0e205518573e21c44c28c784b.jpg";